<h2 mat-dialog-title>{{ id ? "Update" : "Create" }} Auto Archive Rule</h2>
<mat-dialog-content class="auto-archive-dialog">
    <form #ruleForm="ngForm">
        <div class="dialog-columns">
            <div class="column">
                <h3>General Information</h3>

                <mat-form-field>
                    <mat-label>Endpoint</mat-label>
                    <input
                        matInput
                        [(ngModel)]="endpoint"
                        name="endpoint"
                        required
                        #endpointInput="ngModel"
                    />
                    <mat-error
                        *ngIf="endpointInput.invalid && endpointInput.touched"
                    >
                        Endpoint is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Method</mat-label>
                    <mat-select
                        [(ngModel)]="method"
                        name="method"
                        required
                        #methodInput="ngModel"
                    >
                        <mat-option value="POST">POST</mat-option>
                        <mat-option value="PUT">PUT</mat-option>
                        <mat-option value="PATCH">PATCH</mat-option>
                        <mat-option value="DELETE">DELETE</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="methodInput.invalid && methodInput.touched"
                    >
                        Method is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Sending System</mat-label>
                    <input
                        matInput
                        [(ngModel)]="sendingSystem"
                        name="sendingSystem"
                        required
                        #sendingSystemInput="ngModel"
                    />
                    <mat-error
                        *ngIf="
                            sendingSystemInput.invalid &&
                            sendingSystemInput.touched
                        "
                    >
                        Sending System is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Sending Unit</mat-label>
                    <input
                        matInput
                        [(ngModel)]="sendingUnit"
                        name="sendingUnit"
                    />
                </mat-form-field>
            </div>

            <div class="column">
                <h3>Conditions</h3>

                <div
                    *ngFor="let condition of conditions; let i = index"
                    class="condition-row"
                >
                    <mat-form-field>
                        <mat-label>Property</mat-label>
                        <input
                            matInput
                            [(ngModel)]="condition.property"
                            [name]="'property_' + i"
                            required
                            #propertyInput="ngModel"
                        />
                        <mat-error
                            *ngIf="
                                propertyInput.invalid && propertyInput.touched
                            "
                        >
                            Property is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Pattern Type</mat-label>
                        <mat-select
                            [(ngModel)]="condition.displayRegexPatternType"
                            [name]="'patternType_' + i"
                            required
                            #patternTypeInput="ngModel"
                        >
                            <mat-option
                                *ngFor="let type of patternTypes"
                                [value]="type.value"
                            >
                                {{ type.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                patternTypeInput.invalid &&
                                patternTypeInput.touched
                            "
                        >
                            Pattern Type is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Value</mat-label>
                        <input
                            matInput
                            [(ngModel)]="condition.displayRegexValue"
                            [name]="'value_' + i"
                            required
                            #valueInput="ngModel"
                        />
                        <mat-error
                            *ngIf="valueInput.invalid && valueInput.touched"
                        >
                            Value is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Discovery Code</mat-label>
                        <input
                            matInput
                            [(ngModel)]="condition.errorCode"
                            [name]="'errorCode_' + i"
                            #errorCodeInput="ngModel"
                        />
                    </mat-form-field>
                    <button
                        mat-icon-button
                        type="button"
                        (click)="removeCondition(i)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>

                <button mat-button type="button" (click)="addCondition()">
                    <mat-icon>add</mat-icon>
                    Add Condition
                </button>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button type="button" [mat-dialog-close]>Cancel</button>
    <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="onSave()"
        cdkFocusInitial
    >
        Save
    </button>
</mat-dialog-actions>
